export const DESKTOP_ARTICLES_PER_PAGE = 18;
export const MOBILE_ARTICLES_PER_PAGE = 6;
